var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.$style.button, _setup.isLiked && _vm.$style.isLiked],on:{"click":function($event){$event.stopPropagation();return _setup.onClick.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_setup.itemStore.likedCounts[_vm.itemId] || 0)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }